import styled from "@emotion/styled";
import { TextField } from "./TextField";
import { translate } from "@kaltura/mediaspace-shared-utils";
import { baseInputClasses } from "@kaltura/ds-react-components";

export interface TimeInputFieldProps {
    /**
     * The field name for react-hook-form registration
     */
    fieldName: string;
    /**
     * The label text for the input field
     */
    label: string;
    /**
     * Optional additional information/help text
     */
    additionalInfo?: string;
    /**
     * The default value in minutes (optional)
     */
    defaultValue?: string | number;
}

const StyledTextField = styled(TextField)(() => ({
    [`& .${baseInputClasses.root}`]: {
        width: 60,
    },
}));

/**
 * TimeInputField component for entering time values in minutes.
 * Generic component that can be used across different forms and contexts.
 */
export const TimeInputField = ({ fieldName, label, additionalInfo, defaultValue }: TimeInputFieldProps) => {
    return (
        <StyledTextField
            inline={true}
            fontWeightBold={true}
            displayErrors={true}
            label={label}
            defaultValue={defaultValue?.toString()}
            id={fieldName}
            additionalInfo={additionalInfo}
            registerOptions={{
                pattern: {
                    value: /^[0-9]*$/,
                    message: translate("Please enter a valid number"),
                },
            }}
            postText={translate("Minutes")}
        />
    );
};

export default TimeInputField;
